module.exports = __webpack_public_path__ + "static/media/autochilango-provider.5535cc4a.svg";